import type { TreatmentStep } from '../../lib/localDB';

export type StepDefinition = {
  step_id: string;
  label: string;
  short: string;
  icon: string;
  color: string;
};

export const STEP_DEFINITIONS: StepDefinition[] = [
  {
    step_id: 'kontrol_10d',
    label: 'Ameliyat Sonrası Kontrol',
    short: '10. Gün',
    icon: 'ri-stethoscope-line',
    color: 'teal',
  },
  {
    step_id: 'kontrol_2ay',
    label: '2. Ay Kontrol',
    short: '2. Ay',
    icon: 'ri-calendar-check-line',
    color: 'cyan',
  },
  {
    step_id: 'healing_olcu',
    label: 'Healing / Ölçü',
    short: '3. Ay',
    icon: 'ri-scan-line',
    color: 'emerald',
  },
  {
    step_id: 'prova',
    label: 'Prova',
    short: '1 Hafta',
    icon: 'ri-tools-line',
    color: 'amber',
  },
  {
    step_id: 'teslim',
    label: 'Teslim',
    short: '3 Gün',
    icon: 'ri-gift-line',
    color: 'orange',
  },
  {
    step_id: 'final_kontrol',
    label: 'Final Kontrol',
    short: '2 Gün',
    icon: 'ri-checkbox-circle-line',
    color: 'green',
  },
];

export function addDays(dateStr: string, days: number): string {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

export function buildInitialSteps(operationDate: string): TreatmentStep[] {
  const s1Planned = addDays(operationDate, 10);
  const s2Planned = addDays(operationDate, 60);
  const s3Planned = addDays(operationDate, 90);
  const s4Planned = addDays(s3Planned, 7);
  const s5Planned = addDays(s4Planned, 3);
  const s6Planned = addDays(s5Planned, 2);

  return [
    { step_id: 'kontrol_10d', label: 'Ameliyat Sonrası Kontrol', completed: false, completed_date: null, planned_date: s1Planned },
    { step_id: 'kontrol_2ay', label: '2. Ay Kontrol', completed: false, completed_date: null, planned_date: s2Planned },
    { step_id: 'healing_olcu', label: 'Healing / Ölçü', completed: false, completed_date: null, planned_date: s3Planned },
    { step_id: 'prova', label: 'Prova', completed: false, completed_date: null, planned_date: s4Planned },
    { step_id: 'teslim', label: 'Teslim', completed: false, completed_date: null, planned_date: s5Planned },
    { step_id: 'final_kontrol', label: 'Final Kontrol', completed: false, completed_date: null, planned_date: s6Planned },
  ];
}

export function recalcPlannedDates(steps: TreatmentStep[]): TreatmentStep[] {
  const result = [...steps];
  const dep: { idx: number; basedOnIdx: number; days: number }[] = [
    { idx: 3, basedOnIdx: 2, days: 7 },
    { idx: 4, basedOnIdx: 3, days: 3 },
    { idx: 5, basedOnIdx: 4, days: 2 },
  ];
  dep.forEach(({ idx, basedOnIdx, days }) => {
    const base = result[basedOnIdx];
    const baseDate = base.completed ? base.completed_date! : base.planned_date!;
    if (baseDate) {
      result[idx] = { ...result[idx], planned_date: addDays(baseDate, days) };
    }
  });
  return result;
}

export function getStepStatus(
  step: TreatmentStep,
  today: string
): 'completed' | 'overdue' | 'due_soon' | 'upcoming' {
  if (step.completed) return 'completed';
  if (!step.planned_date) return 'upcoming';
  const planned = new Date(step.planned_date);
  const todayDate = new Date(today);
  const diffDays = Math.ceil((planned.getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return 'overdue';
  if (diffDays <= 7) return 'due_soon';
  return 'upcoming';
}
